"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Simple = exports.Menu = exports.Main = exports.Footer = exports.Container = exports.Center = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _mixins = require("../mixins");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Layout__Container",
  componentId: "sc-1f1uvdw-0"
})(["position:relative;height:", ";width:100%;overflow:hidden;display:flex;"], function (props) {
  var _ref, _props$h;
  return (_ref = (_props$h = props.h) !== null && _props$h !== void 0 ? _props$h : props.height) !== null && _ref !== void 0 ? _ref : "100vh";
});
exports.Container = Container;
var withFooterAtEnd = (0, _styledComponents.css)(["padding-bottom:", ";"], function (props) {
  return props.theme.spaces.m;
});
var mainContainerStyles = (0, _styledComponents.css)(["", ";padding:", ";", ";", ";display:flex;position:relative;flex-direction:column;", ""], function (props) {
  return (0, _mixins.backgroundMixin)(props.theme.layouts.backgroundColor);
}, function (props) {
  var _props$theme$layouts$;
  return "".concat(props.theme.layouts.p, " ").concat((_props$theme$layouts$ = props.theme.layouts.pH) !== null && _props$theme$layouts$ !== void 0 ? _props$theme$layouts$ : props.theme.layouts.p);
}, _mixins.paddingMixin, withFooterAtEnd, function (props) {
  return props.alignItems && (0, _styledComponents.css)(["align-items:", ";"], props.alignItems);
});
var Simple = (0, _styledComponents["default"])(Container).attrs(function (props) {
  return {
    alignItems: props.alignItems || "center"
  };
}).withConfig({
  displayName: "Layout__Simple",
  componentId: "sc-1f1uvdw-1"
})(["", ";height:", ";min-height:100vh;"], mainContainerStyles, function (props) {
  return props.h || props.height || "100%";
});
exports.Simple = Simple;
var Center = (0, _styledComponents["default"])(_Box["default"]).attrs(function (props) {
  return {
    d: "flex",
    w: props.width || props.w || "100%",
    h: props.height || props.h,
    direction: props.direction || "column"
  };
}).withConfig({
  displayName: "Layout__Center",
  componentId: "sc-1f1uvdw-2"
})(["max-width:100%;height:100%;flex-grow:1;justify-content:center;align-items:center;"]);
exports.Center = Center;
var Main = _styledComponents["default"].main.withConfig({
  displayName: "Layout__Main",
  componentId: "sc-1f1uvdw-3"
})(["", ";flex:1;height:100%;overflow-y:auto;overflow-x:hidden;"], mainContainerStyles);
exports.Main = Main;
var Menu = _styledComponents["default"].aside.withConfig({
  displayName: "Layout__Menu",
  componentId: "sc-1f1uvdw-4"
})(["", ";"], (0, _mixins.backgroundMixin)("menuBackground"));
exports.Menu = Menu;
var FooterContainer = _styledComponents["default"].div.withConfig({
  displayName: "Layout__FooterContainer",
  componentId: "sc-1f1uvdw-5"
})(["position:relative;height:0;overflow:visible;width:100%;font-size:", ";line-height:", ";color:", ";text-align:center;margin-top:auto;> span{position:absolute;top:0;left:50%;transform:translateX(-50%);z-index:2;}&::before{content:\"\";position:absolute;width:100%;height:", ";z-index:1;bottom:;left:0;background-color:", ";}"], function (props) {
  return props.theme.fontSizes.xs;
}, function (props) {
  return props.theme.layouts.p;
}, function (props) {
  return props.theme.colors.textSecondary;
}, function (props) {
  return props.theme.layouts.p;
}, function (props) {
  return props.theme.colors.backgroundTertiary;
});
var Footer = function Footer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(FooterContainer, null, /*#__PURE__*/_react["default"].createElement("span", null, children || "© AirportLabs Limited"));
};
exports.Footer = Footer;
Footer.propTypes = {
  children: _propTypes["default"].node
};